import dayjs from 'dayjs'

const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '京东收款单编号',
      dataIndex: 'billNo',
      width: 100,
    },
    {
      title: '应收金额',
      dataIndex: 'receivableAmount',
      width: 100,
    },
    {
      title: '实收金额',
      dataIndex: 'receiveAmount',
      width: 100,
    },
    {
      title: '支付状态',
      dataIndex: 'payStateName',
      width: 136,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      width: 136,
      render: value => <span>{value ? dayjs(value).format('YYYY-MM-DD HH:mm') : ''}</span>,
    },

    {
      title: '收款时间',
      dataIndex: 'receivedTime',
      itemType: 'dateTime',
      width: 160,
      render: value => <span>{value ? dayjs(value).format('YYYY-MM-DD HH:mm') : ''}</span>,
    },
    {
      title: '关联收款单',
      dataIndex: 'transLog',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 180,
      render: 'actions',
    },
  ],
  search: [],
}

export default config
